export default __webpack_public_path__ + "static/media/background.9c3514ee.jpg";